<template>
  <v-container fluid align-start ma-0 pa-2 class="epms9020-main container-height">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-row no-gutters>
              <v-col>
                <i-card-top
                  class="d-md-flex"
                  outlined
                  :useBtnList="useBtnList"
                  :customBtnList="customBtnList"
                  @btnMakeDeliNote="btnMakeDeliNote"
                  @btnNew="btnNew"
                  @btnPrint="btnPrint"
                  @btnDelete="btnDelete"
                  @btnToExcel="btnToExcel"
                >
                  <template v-slot:body>
                    <v-row no-gutters class="center pa-2 pb-0">
                      <i-label :label="'Delivery No :'" />
                      <v-col cols="2">
                        <v-select
                          v-model="selectDelyNo"
                          :items="delyNoList"
                          return-object
                          item-text="delyNo"
                          item-value="delyNo"
                          single-line
                          outlined
                          dense
                          height="32" 
                          @change="delyNoChanged()"/>
                      </v-col>

                    <i-label :label="'Delivery Plan Date :'" class="pl-2" />
                    <v-col cols="2">
                      <DxDateBox
                        :value="delyDte"
                        height="32px"
                        display-format="yyyy-MM-dd"
                        :acceptCustomValue="false"
                        @value-changed="e => {delyDte = e.value && getStrFormat(e.value)}"
                        :disabled="searchDelyNo === '' ? false : true"
                      />
                    </v-col>
                      
                    <i-label :label="'Keep Loc :'" class="pl-2" />
                    <v-col cols="2">
                      <v-select
                        v-model="selectKeepLoc"
                        :items="keepLocList"
                        return-object
                        item-text="codeName"
                        item-value="code"
                        single-line
                        outlined
                        dense
                        height="32" />
                      </v-col>
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>

            <v-row no-gutters class="pt-1 pb-4">
              <v-col>
                <DxDataGrid
                  :ref="epms9020Ref"
                  :data-source="dataList" 
                  :remote-operations="false" 
                  :hover-state-enabled="true"
                  :allow-column-resizing="true" 
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true" 
                  :show-borders="true" 
                  :width="grid.width"
                  :show-row-lines="true" 
                  key-expr="rnum" 
                  :focused-row-enabled="false"
                  :column-hiding-enabled="false" 
                  :sorting="{ mode: 'none' }"
                >
                  <DxPaging :enabled="false" />
                  <DxPager :visible="false" />
                  <DxColumn data-field="shipNo" caption="Ship No" width="5%" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="porNo" caption="POR No" width="7%" alignment="center" :allow-editing="false"
                                        cell-template="porNoCellTmpl" />
                  <template #porNoCellTmpl="{ data: cellInfo }">
                    <div class="d-flex justify-center">
                      <div class="cursor-pointer text-hover bold-hover" @click.stop="clickPorNo(cellInfo.data.porNo)">
                        {{ `${cellInfo.data.porNo}` }}
                      </div>
                      <div>
                        {{ `-${cellInfo.data.porSeq}` }}
                      </div>
                    </div>
                  </template>
                  <DxColumn data-field="block" caption="Block" width="5%" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="mact" caption="M.Act" width="7%" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="partNo" caption="Part No" width="7%" alignment="center" :allow-editing="false"/>
                  <DxColumn data-field="matlSpec" caption="Part Specification" alignment="left" :allow-editing="false" />
                  <DxColumn data-field="delyQty" caption="Qty" width="5%" alignment="right" data-type="number" format="#,##0" :allow-editing="false" />
                  <DxColumn data-field="matlUnit" caption="Unit" width="4%" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="resNo" caption="Order No" width="7%" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="resSeq" caption="Seq" width="4%" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="delivLoc" caption="Location" width="5%" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="reqDelivDte" width="7%" alignment="center" :allow-editing="false"
                                        header-cell-template="requiredDateHeaderTmpl" />
                  <template #requiredDateHeaderTmpl>
                    <fragment>
                      Required<br>Date
                    </fragment>
                  </template>

                  <DxSelection select-all-mode="allMode" show-check-boxes-mode="always" mode="multiple" />

                  <DxSummary>
                    <DxTotalItem column="block" summary-type="count" display-format="SUM" />
                    <DxTotalItem column="delyQty" summary-type="sum" :customize-text="totalFormat" />
                  </DxSummary>

                </DxDataGrid>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col>
                <i-card-top
                  class="d-md-flex"
                  outlined
                  :useBtnList="useBtnList2"
                  @btnRetrieve="btnRetrieve"
                >
                  <template v-slot:body>
                    <v-row no-gutters class="center pa-2 pb-0">
                      <i-label :label="'Ship No :'" />
                      <v-col cols="1">
                        <v-autocomplete
                          v-model="selectShipNo"
                          :items="shipNoList"
                          return-object
                          item-text="shipNo"
                          item-value="shipNo"
                          single-line
                          outlined
                          dense
                          height="32"
                          @change="changeShipNo" />
                      </v-col>

                      <i-label :label="'Block :'" class="pl-2" />
                      <v-col cols="1">
                        <v-autocomplete
                          v-model="selectBlock"
                          :items="blockList"
                          return-object
                          item-text="block"
                          item-value="block"
                          single-line
                          outlined
                          dense
                          height="32" />
                      </v-col>

                      <i-label :label="'POR No :'" class="pl-2" />
                      <v-col cols="1">
                        <v-autocomplete
                          v-model="selectPorNo"
                          :items="porNoList"
                          return-object
                          item-text="porNo"
                          item-value="porNo"
                          single-line
                          outlined
                          dense
                          height="32" />
                      </v-col>
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>

            <v-row no-gutters class="pt-1 pb-2">
              <v-col>
                <DxDataGrid
                  :ref="epms9020Ref2"
                  :data-source="dataList2" 
                  :remote-operations="false" 
                  :hover-state-enabled="true"
                  :allow-column-resizing="true" 
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true" 
                  :show-borders="true" 
                  :width="grid.width"
                  :show-row-lines="true" 
                  key-expr="rnum" 
                  :focused-row-enabled="false"
                  :column-hiding-enabled="false" 
                  :selection="{ mode: 'none' }"
                  :sorting="{ mode: 'none' }"
                >
                  <DxPaging :enabled="true" :page-size="setPageRows" />
                  <DxPager :show-page-size-selector="false" />
                  <DxEditing :allow-updating="true" />
                  <DxColumn data-field="reqDelivDte" width="6%" alignment="center" :allow-editing="false"
                                        header-cell-template="requiredDateHeaderTmpl" />
                  <template #requiredDateHeaderTmpl>
                    <fragment>
                      Required<br>Date
                    </fragment>
                  </template>
                  <DxColumn data-field="resNo" caption="Order No" width="6%" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="resSeq" caption="Seq" width="4%" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="reqWhDte" width="6%" alignment="center" :allow-editing="false"
                                        header-cell-template="conDateHeaderTmpl" />
                  <template #conDateHeaderTmpl>
                    <fragment>
                      Req Issue<br>Con' Date
                    </fragment>
                  </template>
                  <DxColumn data-field="chk" data-type="string" width="2%" header-cell-template="chkHeader" cell-template="chkCell" :allow-editing="false" />
                  <template #chkHeader = "{ data: cellInfo }" >
                    <DxCheckBox :value="false" :onValueChanged="value => onValueChanged(value, cellInfo)" />
                  </template>
                  <template #chkCell = "{ data: cellInfo }">
										<DxCheckBox :value="cellInfo.value" :onValueChanged="value => onValueChanged(value, cellInfo)"/>
                  </template> 
                  <DxColumn data-field="shipNo" caption="Ship No" width="5%" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="porNo" caption="POR No" width="7%" alignment="center" :allow-editing="false"
                                        cell-template="porNoCellTmpl" />
                  <template #porNoCellTmpl="{ data: cellInfo }">
                    <div class="d-flex justify-center">
                      <div class="cursor-pointer text-hover bold-hover" @click.stop="clickPorNo(cellInfo.data.porNo)">
                        {{ `${cellInfo.data.porNo}` }}
                      </div>
                      <div>
                        {{ `-${cellInfo.data.porSeq}` }}
                      </div>
                    </div>
                  </template>
                  <DxColumn data-field="moneUnit" width="5%" alignment="center" :allow-editing="false"
                                        header-cell-template="moneUnitHeaderTmpl" />
                  <template #moneUnitHeaderTmpl>
                    <fragment>
                      Money<br>Unit
                    </fragment>
                  </template>
                  <DxColumn data-field="mact" caption="M.Act" width="6%" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="partNo" caption="Part No" width="5%" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="partSpec" caption="Part Specification" alignment="left" :allow-editing="false" />
                  <DxColumn data-field="partQty" caption="Qty" width="3%" alignment="right" data-type="number" format="#,##0" :allow-editing="false" />
                  <DxColumn data-field="matlUnit" caption="Unit" width="3%" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="delivLoc" caption="Location" width="5%" alignment="center" :allow-editing="false"
                                        cell-template="delivLocCellTmpl" />
                  <template #delivLocCellTmpl="{ data: cellInfo }">
                    <div class="text-bold cursor-pointer" @click.stop="clickDelivLoc(cellInfo)">
                      {{ cellInfo.data.delivLoc }}
                    </div>
                  </template>
                  <DxColumn data-field="reqEmp" caption="Requester" width="15%" alignment="center" :allow-editing="false" />

                  <DxSummary>
                    <DxTotalItem column="porNo" summary-type="count" display-format="SUM" />
                    <DxTotalItem column="partQty" summary-type="sum" :customize-text="totalFormat" />
                  </DxSummary>
                </DxDataGrid>
              </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>

    <drawingPagePop v-if="showPop" :showPop.sync="showPop" :gbn="'POR'" :paramNo="dwgPorNo" />
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import DxDateBox from 'devextreme-vue/date-box'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { getNumComma, getDateFormat, getCurrentDate } from '@/utils/common.js'
import { getDelyNoList, epms9020DelyList, epms9020PoList, epms9020Save, epms9020Delete, epms9020Xls } from '@/api/view/hip/90/epms9020'
import { getShipNoList1, epms9000_block, epms9000_por_no } from '@/api/view/hip/common/common.js'
import drawingPagePop from '@/views/hip/common/drawingPagePop'
import { reportView } from '@/api/view/hip/common/common'
import notify from 'devextreme/ui/notify'

export default {
  name: 'epms9020',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxDateBox,
    drawingPagePop
  },
  data() {
    return {
      menuTitle: this.$route.meta.title + ' of Fabrication Items',
      makerCd: this.$store.state.user.makerCd,
      userId: this.$store.state.user.userId,
      userIp: this.$store.state.user.userIp,
      showPop: false,
      useBtnList: ['btnMakeDeliNote', 'btnNew', 'btnPrint', 'btnDelete', 'btnToExcel'],
      useBtnList2: ['btnRetrieve'],
      customBtnList: [
        { id: 'btnToExcel', text: 'To Excel', icon: 'excel' }
      ],
      epms9020Ref: 'epms9020Ref',
      epms9020Ref2: 'epms9020Ref2',
      setPageRows: 50,
      selectDelyNo: null,
      delyNoList: [],
      delyDte: getCurrentDate(),
      selectKeepLoc: null,
      keepLocList: [],
      dataList: [],
      dataList2: [],
       selectShipNo: null,
      shipNoList: [],
      shipNo: '',
      selectBlock: null,
      blockList: [],
      selectPorNo: null,
      porNoList: [],
      dwgPorNo: ''
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epms9020Ref)
    },
    grid2Instance() {
      return this.GetDataGrid(this.epms9020Ref2)
    },
    searchDelyNo() {
      return !this.selectDelyNo || this.selectDelyNo.delyNo === 'New' ? '' : this.selectDelyNo.delyNo
    }
  },
  methods: {
    totalFormat(e) {
        const result = getNumComma(Number(e.value.toFixed(2)), 2)
        return result 
    },
    init() {
      this.gridInstance.option('defaultPaging', false)
      this.grid2Instance.option('defaultPaging', false)
    },
    async getDelyNoList() {
      this.delyNoList = [{
        delyNo: 'New'
      }]
      this.selectDelyNo = this.delyNoList[0]

      const param = {
        makerCd: this.makerCd
      }

      // console.log('getDelyNoListParam', param)

      await getDelyNoList(param).then(res => {
        // console.log('getDelyNoListRes', res)

        const data = res.list
        
        data.forEach(item => {
          this.delyNoList.push(item)
        })
      })
    },
    async getKeepLoc() {
      await getCmChildCode({
        code: '',
        codegr: '',
        prtCode: 'KEEP_LOC',
        userFlag: 'Y'
      }).then(res => {
        this.keepLocList = res.list
        this.keepLocList.unshift({
          code: '',
          codeName: ''
        })
        this.selectKeepLoc = this.keepLocList[0]
      })
    },
    async delyNoChanged() {
      this.gridInstance.clearSelection()
      this.dataList = []
      const param = {
        makerCd: this.makerCd,
        delyNo: this.searchDelyNo
      }

      // console.log('delyNoChangedParam', param)

      this.openLoading()
      await epms9020DelyList(param).then(res => {
        // console.log('delyNoChangedRes', res)

        this.dataList = res.list

        if(this.dataList.length > 0) {
          this.delyDte = this.dataList[0].delyDte
        } else {
          this.delyDte = getCurrentDate()
        }
      }).finally(() => {
        this.endLoading()
      })

      await this.retrievePo()
    },
    async getShipNoList() {
      const param = {
        makerCd: this.makerCd
      }

      await getShipNoList1(param).then(async res => {
        // console.log('getShipNoList1Res', res)

        this.shipNoList = res.list
        this.shipNoList.unshift({
          shipNo: ''
        })
        this.selectShipNo = this.shipNoList[0]

        await this.getBlockList()
        await this.getPorNoList()
      })
    },
    async getBlockList() {
      this.openLoading()

      const param = {
        incNotPo: 'Y',
        shipNo: this.selectShipNo.shipNo,
        makerCd: this.makerCd
      }

      await epms9000_block(param).then(res => {
        // console.log('epms9000_blockRes', res)

        this.blockList = res.list
        this.blockList.unshift({
          block: ''
        })
        this.selectBlock = this.blockList[0]
      }).finally(() => {
        this.endLoading()
      })
    },
    async getPorNoList() {
      this.openLoading()

      const param = {
        incNotPo: 'Y',
        shipNo: this.selectShipNo.shipNo,
        makerCd: this.makerCd
      }

      await epms9000_por_no(param).then(res => {
        // console.log('epms9000_blockRes', res)

        this.porNoList = res.list
        this.porNoList.unshift({
          porNo: ''
        })
        this.selectPorNo = this.porNoList[0]
      }).finally(() => {
        this.endLoading()
      })
    },
    async changeShipNo() {
      this.selectBlock = null
      this.blockList = []
      this.selectPorNo = null
      this.porNoList = []

      await this.getBlockList()
      await this.getPorNoList()
    },
    async btnRetrieve() {
      if(!this.selectBlock || !this.selectBlock.block) {
        this.vToastify(this.$t('Please select block!'), 'warn')
        return
      }
        
      this.retrievePo()
    },
    async retrievePo() {
      this.grid2Instance.clearSelection()
      this.dataList2 = []

      const param = {
        hndYn: 'N',
        shipNo: this.selectShipNo.shipNo,
        porNo: this.selectPorNo ? this.selectPorNo.porNo : '',
        block: this.selectBlock ? this.selectBlock.block : '',
        makerCd: this.makerCd
      }

      // console.log('retrievePoParam', param)

      this.openLoading()
      epms9020PoList(param).then(res => {
        // console.log('retrievePoRes', res)

        let data = res.list
        data.forEach(item => {
          item.chk = false
        })

        this.dataList2 = data
      }).finally(() => {
        this.endLoading()
      })
    },
    async btnMakeDeliNote() {
      await this.grid2Instance.saveEditData()

      let locNo = this.dataList2.length > 0 ? this.dataList2[0].locNo : ''
      let shipNo = this.dataList2.length > 0 ? this.dataList2[0].shipNo : ''
      const locOpt = this.selectKeepLoc.code

      // console.log('locNo', locNo)
      // console.log('shipNo', shipNo)
      // console.log('locOpt', locOpt)

      let makeData = await this.grid2Instance.getSelectedRowsData()
      console.log('makeData', makeData)

      if(makeData.length < 1) {
        this.vToastify(this.$t('Data is not selected.'), 'warn')
        return
      }

      for(let i = 0; i < makeData.length; i++) {
        let _shipNo = makeData[i].shipNo
        let _locNo = makeData[i].delivLoc

       // console.log('BOMSER row ' + i + ': ' + makeData[i].partNo )

        if(!shipNo) {
          shipNo = _shipNo
        }

        if(!locNo) {
          locNo = _locNo
        }

        if(shipNo !== _shipNo) {
          this.vToastify(this.$t('Ship No is different.'), 'warn')

          const cells = this.grid2Instance.getRowElement((makeData[i].rnum * 1) - 1)[0].querySelectorAll('td')
          cells.forEach(cell => {
            cell.style.backgroundColor = '#FF0000'
          })

          return
        }

        if(locNo !== _locNo) {
          this.vToastify(this.$t('Location is different.'), 'warn')

          const cells = this.grid2Instance.getRowElement((makeData[i].rnum * 1) - 1)[0].querySelectorAll('td')
          cells.forEach(cell => {
            cell.style.backgroundColor = '#FF0000'
          })

          return
        }

        if(_locNo === 'Z399' && locOpt != 'H1' && locOpt != 'H2' && locOpt != 'H3' && locOpt != 'H4' && locOpt != 'H5' && locOpt != 'M') {
          if(this.makerCd === '90263' || this.makerCd === '95987') {
            this.vToastify(this.$t('Please select location keep Material.'), 'warn')
            return
          }
        }

        makeData[i].delyNo = this.searchDelyNo
        makeData[i].delyDte = this.delyDte
        makeData[i].locOpt = locOpt
        makeData[i].userId = this.userId
      }

      this.openLoading()
      // console.log('epms9020SaveParam', makeData)

      epms9020Save(makeData).then(async res => {
        // console.log('epms9020SaveRes', res)

        const resMsg = res.map.msg
        const resDelyNo = res.map.delyNo

        if(resMsg === 'OK') {
          notify(this.$t('Saving is complted.'), 'success', 3000)
          await this.getDelyNoList()
          this.selectDelyNo = this.$_.find(this.delyNoList, { delyNo: resDelyNo })
          this.delyNoChanged()
        } else {
          this.vToastify(this.$t(resMsg), 'warn')
        }
      }).finally(() => {
        this.endLoading()
      })
    },
    btnNew() {
      this.selectDelyNo = this.delyNoList[0]
      // this.delyDte = getCurrentDate()
      this.delyNoChanged()
    },
    btnPrint() {
      let param = {
        as_dely_no: this.searchDelyNo,
        as_maker_cd: this.$store.state.user.makerCd
      }

      if(this.makerCd === '90263'|| this.makerCd === '95987') {
        param.fileName = 'epms9020.jrxml'
      } else {
        param.fileName = 'epms9020_vat.jrxml'
      }

      // console.log('param', param)

      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    async btnDelete() {

      let delData = await this.gridInstance.getSelectedRowsData()
            
      if(delData.length < 1) {
        this.vToastify(this.$t('Data is not selected.'), 'warn')
        return
      }

      for(let i = 0; i < delData.length; i++) {
        delData[i].makerCd = this.$store.state.user.makerCd
      }

      this.vToastifyPrompt(
        this.$t('Do you want to delete the data?'),
        'info',
        async current => {
          this.openLoading()

          epms9020Delete(delData).then(async res => {
            // console.log('btnDeleteRes', res)

            const msg = res.body
            const resDelyNo = this.searchDelyNo
            if(msg === 'OK') {
              notify(this.$t('Deleting is completed.'), 'success', 3000)
              await this.getDelyNoList()
              // console.log('this.$_.find(this.delyNoList, { delyNo: resDelyNo })', this.$_.find(this.delyNoList, { delyNo: resDelyNo }))
              const delDelyNo = this.$_.find(this.delyNoList, { delyNo: resDelyNo })
              // console.log('delDelyNo', delDelyNo)
              if(delDelyNo) {
                this.selectDelyNo = delDelyNo
              }
              this.delyNoChanged()
            } else {
              this.vToastify(this.$t(`An error has been occured while deleting data.<br>${msg}`), 'warn')
              return
            }
          }).finally(() => {
            this.endLoading()
          })
        },
        null,
        true
      )
    },
    btnToExcel() {
      this.openLoading()
      const param = {
        makerCd: this.makerCd,
        delyNo: this.searchDelyNo
      }

      epms9020Xls(param).finally(() => {
        this.endLoading()
      })
    },
    async onValueChanged(value, cellInfo) {
      // console.log('value', value)
      // console.log('cellInfo', cellInfo)

      if(cellInfo.rowType === 'header') {
        this.grid2Instance.beginUpdate()
        let locNo
        if(this.dataList.length > 0) {
          locNo = this.dataList2[0].locNo
        }

        const visibleRows = await this.grid2Instance.getVisibleRows()

        for(let i = 0; i < visibleRows.length; i++) {
          const idx = i + (this.setPageRows * this.grid2Instance.pageIndex())
          const _locNo = visibleRows[i].data.delivLoc

          if(!locNo) {
            locNo = _locNo
          }

          if(this.dataList2[idx].chk !== value.value) {
            if(value.value) {
              if(locNo === _locNo) {
                this.dataList2[idx].chk = value.value
                await this.grid2Instance.selectRows([visibleRows[i].key], true)
              }
            } else {
              this.dataList2[idx].chk = value.value
              await this.grid2Instance.deselectRows([visibleRows[i].key])
            }
          }
        }
        this.grid2Instance.endUpdate()
      } else {
        const idx = cellInfo.rowIndex + (this.setPageRows * this.grid2Instance.pageIndex())

        // this.grid2Instance.cellValue(cellInfo.rowIndex, 'chk', value.value)
        this.dataList2[idx].chk = value.value

        if(value.value) {
          this.grid2Instance.selectRows([cellInfo.key], true)
        } else {
          this.grid2Instance.deselectRows([cellInfo.key])
        }
      }
    },
    async clickDelivLoc(e) {
      // console.log('clickDelivLocEvent', e)

      this.grid2Instance.beginUpdate()

      const locNo = e.value
      const visibleRows = await this.grid2Instance.getVisibleRows()

      for(let i = 0; i < visibleRows.length; i++) {
        const idx = i + (this.setPageRows * this.grid2Instance.pageIndex())
        const _locNo = visibleRows[i].data.delivLoc

        if(locNo === _locNo) {
          if(!this.dataList2[idx].chk) {
            this.dataList2[idx].chk = true
              await this.grid2Instance.selectRows([visibleRows[i].key], true)
          }
        } else {
          if(this.dataList2[idx].chk) {
            this.dataList2[idx].chk = false
            await this.grid2Instance.deselectRows([visibleRows[i].key])
          }
        }
      }

      this.grid2Instance.endUpdate()
    },
    clickPorNo(e) {
      console.log('e', e)
      this.dwgPorNo = e
      this.showPop = true
    },
    getNumComma(val) {
      return getNumComma(val)
    },
    getStrFormat(date) {
      return getDateFormat(date)
    }
  },
  async mounted() {
    this.init()
    await this.getDelyNoList()
    await this.getKeepLoc()
    await this.getShipNoList()
  }
}
</script>

<style lang="scss" scoped>
.epms9020-main {
  ::v-deep {
    [role=btnMakeDeliNote], [role=btnPrint]  {
      .v-btn__content {
        div, i {
          color: #0000ff !important;
        }
      }
    }
  }

  ::v-deep {
    [role=btnDelete]  {
      .v-btn__content {
        div, i {
          color: #ff0000 !important;
        }
      }
    }
  }
}
</style>